module.exports = __webpack_public_path__ + "static/media/lucia-hover.be759829.png";